import { render, staticRenderFns } from "./PlaceHolderTable.vue?vue&type=template&id=6141d672&scoped=true&"
import script from "./PlaceHolderTable.vue?vue&type=script&lang=js&"
export * from "./PlaceHolderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141d672",
  null
  
)

export default component.exports